var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCodingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "82px",
    height: "82px",
    viewBox: "0 0 82 82",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "coding-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Extra-Large-Copy",
    transform: "translate(-29, -342)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coding-browser-svgrepo-com",
    transform: "translate(30, 349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.7778125,0 L6.2221875,0 C2.79125,0 0,2.78409925 0,6.20589982 C0,9.00402476 0,60.0075075 0,62.7941002 C0,66.2160566 2.79125,69 6.2221875,69 L73.7778125,69 C77.20875,69 80,66.2160566 80,62.7941002 C80,60.0061049 80,9.00324556 80,6.20589982 C80,2.78409925 77.20875,0 73.7778125,0 Z M74.6667188,62.7941002 C74.6667188,63.2829734 74.2679687,63.6806796 73.7778125,63.6806796 L6.2221875,63.6806796 C5.73203125,63.6806796 5.33328125,63.2829734 5.33328125,62.7941002 L5.33328125,18.5792067 L74.6667188,18.5792067 L74.6667188,62.7941002 L74.6667188,62.7941002 Z M74.6667188,13.2598863 L5.33328125,13.2598863 L5.33328125,6.20589982 C5.33328125,5.71702664 5.73203125,5.31932044 6.2221875,5.31932044 L73.7778125,5.31932044 C74.2679687,5.31932044 74.6667188,5.71702664 74.6667188,6.20589982 L74.6667188,13.2598863 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 11.2195313,
    cy: 9.28983713,
    rx: 2.005625,
    ry: 2.00037492
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 17.6498438,
    cy: 9.28983713,
    rx: 2.005625,
    ry: 2.00037492
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 24.08,
    cy: 9.28983713,
    rx: 2.005625,
    ry: 2.00037492
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.17,53.1106087 C24.6579688,55.5922206 28.4304688,51.8319334 25.94125,49.3492306 L17.6007813,41.0304387 L25.94125,32.7118026 C28.4329688,30.2266063 24.6642188,26.462579 22.17,28.9504245 L11.9440625,39.1495938 C10.9026563,40.188274 10.9026563,41.8722917 11.9440625,42.9109719 L22.17,53.1106087 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8298438,53.1106087 L68.0559375,42.9112836 C69.0967188,41.8735384 69.0973438,40.1884298 68.0559375,39.1499055 L57.8298438,28.9505803 C55.3385938,26.4656958 51.5635938,30.2236454 54.0585938,32.7119584 L62.3992188,41.0305945 L54.0585938,49.3492306 C51.5201563,51.8810233 55.3885938,55.5453125 57.8298438,53.1106087 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2792187,55.644739 L50.54375,29.2751971 C52.3089062,26.2261682 47.6857812,23.5731312 45.9248438,26.615459 L30.6603125,52.9850009 C28.88375,56.0542891 33.53375,58.660418 35.2792187,55.644739 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodingIcon);
export default __webpack_public_path__ + "static/media/coding-icon.61af1cb2679a9c4b43737b1cda6d2622.svg";
export { ForwardRef as ReactComponent };